export var NbtType;
(function (NbtType) {
    NbtType[NbtType["End"] = 0] = "End";
    NbtType[NbtType["Byte"] = 1] = "Byte";
    NbtType[NbtType["Short"] = 2] = "Short";
    NbtType[NbtType["Int"] = 3] = "Int";
    NbtType[NbtType["Long"] = 4] = "Long";
    NbtType[NbtType["Float"] = 5] = "Float";
    NbtType[NbtType["Double"] = 6] = "Double";
    NbtType[NbtType["ByteArray"] = 7] = "ByteArray";
    NbtType[NbtType["String"] = 8] = "String";
    NbtType[NbtType["List"] = 9] = "List";
    NbtType[NbtType["Compound"] = 10] = "Compound";
    NbtType[NbtType["IntArray"] = 11] = "IntArray";
    NbtType[NbtType["LongArray"] = 12] = "LongArray";
})(NbtType || (NbtType = {}));
//# sourceMappingURL=NbtType.js.map